const MONTH_FULL_NAMES: Record<string, string> = {
	// Abbreviated (pt-BR style)
	jan: 'Janeiro',
	'jan.': 'Janeiro',
	fev: 'Fevereiro',
	'fev.': 'Fevereiro',
	mar: 'Março',
	'mar.': 'Março',
	abr: 'Abril',
	'abr.': 'Abril',
	mai: 'Maio',
	'mai.': 'Maio',
	jun: 'Junho',
	'jun.': 'Junho',
	jul: 'Julho',
	'jul.': 'Julho',
	ago: 'Agosto',
	'ago.': 'Agosto',
	set: 'Setembro',
	'set.': 'Setembro',
	out: 'Outubro',
	'out.': 'Outubro',
	nov: 'Novembro',
	'nov.': 'Novembro',
	dez: 'Dezembro',
	'dez.': 'Dezembro',
	// Full pt-BR names (lowercase keys for normalization)
	janeiro: 'Janeiro',
	fevereiro: 'Fevereiro',
	março: 'Março',
	abril: 'Abril',
	maio: 'Maio',
	junho: 'Junho',
	julho: 'Julho',
	agosto: 'Agosto',
	setembro: 'Setembro',
	outubro: 'Outubro',
	novembro: 'Novembro',
	dezembro: 'Dezembro',
};

/**
 * Formats a reference string such as "Jan/2024" or "Janeiro/2025" to
 * the full Portuguese month name format: "Janeiro/2024".
 */
export function formatReferencia(referencia: string): string {
	if (!referencia) return referencia;

	const separatorIndex = referencia.lastIndexOf('/');
	if (separatorIndex === -1) return referencia;

	const monthPart = referencia.slice(0, separatorIndex).trim();
	const yearPart = referencia.slice(separatorIndex + 1).trim();

	const fullName = MONTH_FULL_NAMES[monthPart.toLowerCase()];
	if (!fullName) return referencia;

	return `${fullName}/${yearPart}`;
}
